// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\home.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\home.tsx");
  import.meta.hot.lastModified = "1759761980446.823";
}
// REMIX HMR END

import { ProtectedRoute } from "~/components/RouteProtection";
export const meta = () => {
  return [{
    title: "Home - Nomadics Studios"
  }, {
    name: "description",
    content: "Connect creators with premium studio spaces, professional equipment, and a thriving creative community."
  }];
};
export default function Home() {
  return <ProtectedRoute>
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="text-center px-4">
          <div className="mb-8">
            <img src="/images/logo-white.png" alt="Nomadics Studios" className="h-16 lg:h-20 w-auto mx-auto mb-8" />
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-bold mb-6 tracking-wider">
            COMING SOON
          </h1>
          
          <p className="text-lg lg:text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            We're building something amazing for creators worldwide. 
            <br />
            Premium studio spaces, professional equipment, and a thriving creative community.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="text-sm text-white/60 uppercase tracking-widest">
              Stay tuned for updates
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>;
}
_c = Home;
var _c;
$RefreshReg$(_c, "Home");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;